<template>
  <button
    v-if="members.length > 1 && drawing === false"
    @click="launch(members)"
  >
    Lancer le tirage
  </button>
  <button v-else-if="drawing === true" @click="draw(members)">
    Tirez au sort votre destinataire
  </button>
</template>

<script>
export default {
  emits: ["launch-draw", "launchDraw", "draw-members", "drawMembers"],
  props: {
    members: {
      type: Array,
      required: true,
    },
    drawing: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const launch = (data) => {
      emit("launch-draw", data);
    };
    const draw = (data) => {
      emit("draw-members", data);
    };

    return {
      launch,
      draw,
    };
  },
};
</script>

<style>
button {
  font-family: "Fraunces";
  font-variation-settings: "SOFT" 100, "wght" 600, "WONK" 1, "opsz" 9;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 2rem;
  margin: 0;
  padding: .4rem;
  text-shadow: 5px 3.5px var(--bg);
  background: #fff;
  border-radius: 2rem;
  margin-top: 1rem;
  color: var(--color);
}
button::before, button::after {
  content: " ";
  white-space: pre;
}
</style>